// ─────────────────────────────────────────────────────────────────────────────
// Aliases Reducer
// ─────────────────────────────────────────────────────────────────────────────
// State interface, initial state, and reducer for the productAliases slice.
// ─────────────────────────────────────────────────────────────────────────────

import { Action, createReducer, on } from '@ngrx/store';
import { IPagination } from 'src/app/shared/models/page.model';
import { AliasFilters, IProductAlias } from '../models/alias.models';
import * as aliasesActions from './aliases.actions';

// ── State interface ──────────────────────────────────────────────────────────

export interface ProductAliasesState {
  aliases: IProductAlias[];
  metadata: IPagination | null;
  loading: boolean;
  keyword: string;
  filters: AliasFilters;
}

// ── Initial state ────────────────────────────────────────────────────────────

export const initialProductAliasesState: ProductAliasesState = {
  aliases: [],
  metadata: null,
  loading: false,
  keyword: '',
  filters: { alias_type: '', source: '', customer_id: null, product_id: null, create_date_from: null, create_date_to: null },
};

// ── Reducer ──────────────────────────────────────────────────────────────────

const featureReducer = createReducer(
  initialProductAliasesState,
  on(aliasesActions.LoadAliases, (state) => ({
    ...state,
    loading: true,
  })),
  on(aliasesActions.LoadAliasesSuccess, (state, action) => ({
    ...state,
    loading: false,
    aliases: action.response.data,
    metadata: action.response.metadata,
  })),
  on(aliasesActions.LoadAliasesError, (state) => ({
    ...state,
    loading: false,
  })),
  on(aliasesActions.SetAliasesLoader, (state, action) => ({
    ...state,
    loading: action.isLoading,
  })),
  on(aliasesActions.SetAliasSearch, (state, action) => ({
    ...state,
    keyword: action.keyword,
  })),
  on(aliasesActions.SetAliasFilters, (state, action) => ({
    ...state,
    filters: action.filters,
  })),
);

export function productAliasesReducer(state: ProductAliasesState | undefined, action: Action) {
  return featureReducer(state, action);
}
